import { Transition, Variants } from 'motion/react';

export type SlideTransitionResponse = {
  item: boolean;
  key: string;
  variants: Variants;
  transition: Transition;
}[];

export type SlideTransitionDirection = 'down' | 'up' | 'right' | 'left';

export type SlideTransitionProps = {
  active: boolean;
  direction: SlideTransitionDirection;
  distance?: string;
  config?: Transition;
};

export const slideAxis = {
  down: 'translateY',
  left: 'translateX',
  right: 'translateX',
  up: 'translateY',
};

export const axisModifier = {
  down: '-',
  left: '',
  right: '-',
  up: '',
};

export const getEnterValue = (distance: string) => `0${distance.replace(/\d/g, '')}`;

export function useSlideTransition({
  active,
  direction,
  distance = '10px',
  config = { type: 'spring', stiffness: 300, damping: 30 },
}: SlideTransitionProps): SlideTransitionResponse {
  const variants: Variants = {
    hidden: {
      transform: `${slideAxis[direction]}(${axisModifier[direction]}${distance})`,
    },
    visible: {
      transform: `${slideAxis[direction]}(${axisModifier[direction]}${getEnterValue(distance)})`,
    },
    exit: {
      transform: `${slideAxis[direction]}(${axisModifier[direction]}${distance})`,
    },
  };

  return [
    {
      item: active,
      key: active ? 'visible' : 'hidden',
      variants,
      transition: config,
    },
  ];
}
